const state = {
  myUserInfo: null,
  fcmToken: null,
}

const getters = {
}

const mutations = {
  set_my_user_info (store, data) {
    store.myUserInfo = data
  },
  reset_my_user_info (store) {
    store.myUserInfo = null
  },
  set_fcm_token (store, data) {
    store.fcmToken = data
  },
}

const actions = {
  async fetchMyInfo ({ commit }, role) {
    let loadingInstance = this._vm.$loading({ fullscreen: true })
    try {
      const res = await this._vm.$_services.user.myInfo()
      console.log('TCL: fetchMyInfo -> res', res)
      commit('set_my_user_info', res.data)
      let allowedRoles = role
      if (allowedRoles.indexOf(res.data.role) > -1) {
        loadingInstance.close()
        return res
      } else {
        loadingInstance.close()
        commit('auth/logout', null, { root: true })
        this._vm.$message.error('Anda tidak punya akses untuk membuka halaman ini')
        throw new Error('not allowed')
      }
    } catch (error) {
      loadingInstance.close()
      return Promise.reject(error)
    }
  },
  async fetchFcmToken ({ commit, getters }) {
    let loadingInstance = this._vm.$loading({ fullscreen: true })
    try {
      const fcmToken = await this._vm.$_services.notifications.fetchFcmToken()
      if (fcmToken) {
        console.log('TCL: fetchFcmToken -> fcmToken', fcmToken)
        commit('set_fcm_token', fcmToken)
        loadingInstance.close()
        return fcmToken
      }
    } catch (error) {
      loadingInstance.close()
      return Promise.reject(error)
    }
  }
}

export default {
  namespaced: true,
  getters,
  state,
  actions,
  mutations
}
